<template>
  <Drawer
    v-loading="loading"
    :drawer="drawer"
    :customTitle="false"
    :title="editData.id ? '修改' : '新增'"
    :size="1200"
    @close="close"
  >
    <div class="view">
      <div class="content">
        <el-form ref="form" class="form" :model="supplyData" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="4.8">
              <el-form-item prop="code" label="代码">
                <el-input
                  v-model="supplyData.code"
                  style="width: 200px"
                  placeholder="请输入代码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="wbName" label="简称">
                <el-input
                  v-model="supplyData.wbName"
                  placeholder="请输入简称"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9.6">
              <el-form-item prop="name" label="供应商名称">
                <el-input
                  v-model="supplyData.name"
                  style="width: 420px"
                  placeholder="请输入供应商名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="isActived" label="状态">
                <el-switch
                  v-model="supplyData.isActived"
                  active-color=" rgb(18,88,188)"
                  inactive-color="#f1f1f1"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4.8">
              <el-form-item prop="supplierScope" label="业务范畴">
                <el-select
                  v-model="supplyData.supplierScope"
                  multiple
                  style="width: 420px"
                  placeholder="请选择业务范畴"
                >
                  <el-option
                    v-for="item in supplierScopeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="contact" label="联系人">
                <el-input
                  v-model="supplyData.contact"
                  style="width: 200px"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4.8">
              <el-form-item prop="fmsSecretKey" label="FMS密钥">
                <el-input
                  v-model="supplyData.fmsSecretKey"
                  style="width: 200px"
                  placeholder="请输入FMS密钥"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="ggtSecretKey" label="GGT密钥">
                <el-input
                  v-model="supplyData.ggtSecretKey"
                  style="width: 200px"
                  placeholder="请输入GGT密钥"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="4.8">
              <el-form-item prop="phone" label="联系电话">
                <el-input
                  v-model="supplyData.phone"
                  style="width: 200px"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="email" label="邮箱">
                <el-input
                  v-model="supplyData.email"
                  style="width: 200px"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">

            <el-col :span="14.4">
              <el-form-item prop="truckEmails" label="卡派邮箱">
                <el-input
                  v-model="supplyData.truckEmails"
                  style="width: 640px"
                  placeholder="请输入卡派邮箱,多条已;隔开"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <el-col :span="4.8">
              <el-form-item prop="addressArr" label="地址">
                <el-cascader
                  v-model="supplyData.addressArr"
                  style="width: 200px"
                  :options="addressDropOption"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4.8">
              <el-form-item prop="address" label="详细地址">
                <el-input
                  v-model="supplyData.address"
                  style="width: 860px"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- ========== 新增 DO 信息五个字段 ========== -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="DO名称">
                <el-input
                  v-model="supplyData.doName"
                  placeholder="请输入DO名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="DO联系人">
                <el-input
                  v-model="supplyData.doContact"
                  placeholder="请输入DO联系人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="DO电话">
                <el-input
                  v-model="supplyData.doPhone"
                  placeholder="请输入DO电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="DO地址">
                <el-input
                  v-model="supplyData.doAddress"
                  placeholder="请输入DO地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="DO详细地址">
                <el-input
                  v-model="supplyData.doDetailedAddress"
                  placeholder="请输入DO详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="清关模式" prop="clearanceModes">
                <el-select
                  v-model="supplyData.clearanceModes"
                  style="width: 100%"
                  multiple
                  clearable
                  placeholder="请选择清关模式"
                >
                  <el-option
                    v-for="item in clearanceModesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="supplyData.remark"
                  type="textarea"
                  maxlength="500"
                  :autosize="{ minRows: 2, maxRows: 2 }"
                  placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row style="display: flex">
            <div v-if="file.name" class="fileList">
              <div class="file">
                <div class="qun">
                  <el-progress
                    type="circle"
                    :width="40"
                    :height="40"
                    :stroke-width="4"
                    :percentage="file.percentage"
                  >
                  </el-progress>
                </div>
                <div class="file-item">
                  <p class="fileName">{{ file.name }}</p>
                  <p class="fileSize">{{ file.size | formatSize }} mb</p>
                </div>
              </div>
            </div>
          </el-row> -->
        </el-form>
        <!-- 选项卡区域 -->
        <BaseTab
          style="z-index: 1"
          :tabItems="tabItems"
          :propWidth="490"
          :active="active"
          @tabChange="tabChange"
        ></BaseTab>

        <!-- 根据当前 tab 显示不同内容 -->
        <div class="tab-content">
          <!-- 附件列表 tab -->
          <div v-if="active === 0">
            <div class="add-item-content">
              <div class="title"></div>
              <div class="add-item" style="background: #fff">
                <el-upload
                  class="upload-demo"
                  :action="`api/SystemFile/uploadFile?source=20`"
                  :headers="headers"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="onSuccess"
                  :on-error="onError"
                  accept=".png,.PNG,.psf,.PDF,.JPG,jpg,jpeg,.JPEG"
                  :on-progress="onProgress"
                >
                  <el-button class="btn" size="small">
                    <svg-icon iconClass="upload" className="icon" />
                    选择文件上传
                  </el-button>
                </el-upload>
              </div>
            </div>
            <div class="baseTable">
              <BaseTable
                :isPager="false"
                :tableData="{
                  fileds,
                  columns: supplyData.fileList,
                }"
              >
                <template slot="opt" slot-scope="row">
                  <i
                    title="预览"
                    class="el-icon-zoom-in"
                    @click="review(row.scope)"
                  />
                  <i
                    title="删除"
                    class="el-icon-delete"
                    @click="deleteRow(row.tIndex, row.scope)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>

          <!-- 预报列表 tab -->
          <div v-if="active === 1">
            <div class="add-item-content">
              <div class="title"></div>
              <div class="add-item" style="display: flex; background: #fff">
                <!-- <el-upload
                  class="upload-demo"
                  style="margin-left: 16px"
                  :action="`api/InvoiceTemplate/SaveSupplierTemplate?supplierId=${editData.id}`"
                  :headers="headers"
                  :file-list="fileList"
                  :show-file-list="false"
                  :on-success="onSuccess"
                  :on-error="onError"
                  accept=".xlsx"
                  :on-progress="onProgress"
                > -->
                <el-button
                  class="btn"
                  size="small"
                  @click="dialogVisible3 = true"
                >
                  <svg-icon iconClass="upload" className="icon" />
                  上传预报模板
                </el-button>
                <!-- </el-upload> -->
              </div>
            </div>
            <div class="baseTable">
              <BaseTable
                :isPager="false"
                :tableData="{
                  fileds,
                  columns: tplList,
                }"
              >
                <template slot="opt" slot-scope="row">
                  <el-switch
                    v-model="row.scope.isActived"
                    :active-text="row.scope.isActived ? '启用' : '停用'"
                    @change="onChange(row.tIndex, row.scope, active)"
                  >
                  </el-switch>
                  <i
                    title="预览"
                    class="el-icon-zoom-in"
                    @click="review(row.scope)"
                  />
                  <i
                    title="下载"
                    class="el-icon-download"
                    @click="downloadTpl(row.scope)"
                  />
                  <i
                    title="删除"
                    class="el-icon-delete"
                    @click="deleteRow(row.tIndex, row.scope)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>
          <!-- ===== 银行账号列表 tab（原独立区域迁移至此） ===== -->
          <div v-if="active === 2">
            <div class="add-item-content">
              <div class="title"></div>
              <div class="add-item" @click="add">
                <i class="el-icon-circle-plus-outline" />
                添加银行账号
              </div>
            </div>
            <div class="baseTable">
              <BaseTable
                :isPager="false"
                :tableData="{
                  ...tableData1,
                  columns: bankAccountList,
                }"
              >
                <template slot="opt" slot-scope="row">
                  <el-switch
                    v-model="row.scope.isActived"
                    :active-text="row.scope.isActived ? '启用' : '停用'"
                    @change="onChange(row.tIndex, row.scope, active)"
                  >
                  </el-switch>
                  <!-- <i
                    v-if="row.scope.systemFileGuid"
                    class="el-icon-zoom-in"
                    title="查看文件"
                    @click="checkFile(row.scope.systemFileGuid)"
                  />
                  <img
                    v-if="row.scope.systemFileGuid"
                    class="download"
                    title="下载文件"
                    src="@/assets/images/bill/download.png"
                    @click="download(row.scope.systemFileGuid)"
                  /> -->
                  <i
                    class="el-icon-delete"
                    title="删除"
                    @click="removeBankAccountList(row.tIndex, row.scope)"
                  />
                </template>
              </BaseTable>
            </div>
          </div>
        </div>

        <!-- 原有的银行账号添加弹窗，保持不变 -->
        <add-bank-dialog
          :dialogVisible="dialogVisible2"
          @ok="ok2"
          @cancel="cancel2"
        ></add-bank-dialog>
      </div>
      <SelectTypeUploadDialog
        :dialogVisible="dialogVisible3"
        :clearanceModesOptions="clearanceModesOptions"
        :supplierId="editData.id"
        @cancel="dialogVisible3 = false"
        @ok="
          dialogVisible3 = false;
          getTplList();
        "
      >
      </SelectTypeUploadDialog>
      <div class="foooter flex_c_c">
        <div class="cancel flex_c_c" @click="close">取消</div>
        <div
          v-debounce-click="{ value: ok, args: ['form'] }"
          class="ok flex_c_c"
        >
          确认
        </div>
      </div>
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
import { mapGetters } from 'vuex'
import AddBankDialog from './AddBankDialog.vue'
import SelectTypeUploadDialog from './SelectTypeUploadDialog.vue'
import { isValidEmail } from '@/utils/validate'
import {
  getSysParams,
  insertSupplier,
  updateSupplier,
  switchSupplierBankAccount,
  deleteSupplierBankAccount
} from '@/api/system'
import {
  GetSupplierTemplates,
  deleteSupplierTemplate,
  isActivedSupplierTemplate
} from '@/api/bill'
import config from '@/utils/config'
import { derive } from '@/utils/common'
const BaseTable = () => import('@/components/table/BaseTable')

const BaseTab = () => import('@/components/tab/BaseTab')

export default {
  components: {
    Drawer,
    AddBankDialog,
    BaseTable,
    BaseTab,
    SelectTypeUploadDialog
  },
  filters: {
    formatSize(size) {
      return (size / 1024 / 1024).toFixed(2)
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (value.length !== 4) {
        callback(new Error('请输入4字代码'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!isValidEmail(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    return {
      config,
      supplyData: {
        code: '',
        // nameCH: '',
        // nameEN: '',
        name: '',
        wbName: '',
        contact: '',
        phone: '',
        email: '',
        address: '',
        addressArr: [],
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        remark: '',
        ggtSecretKey: '',
        fmsSecretKey: '',
        isActived: true,
        doName: '',
        doContact: '',
        doPhone: '',
        doAddress: '',
        doDetailedAddress: '',
        supplierScope: [],
        bankAccount: [],
        fileList: [],
        clearanceModes: ''
      },
      dialogVisible3: false,
      tabItems: [
        { id: 0, name: '附件列表' },
        { id: 1, name: '预报模版' },
        { id: 2, name: '银行账号列表' }
      ],
      clearanceModesOptions: config.clearanceModesOptions,
      active: 0,
      bankAccountList: [],
      supplierScopeOptions: [],
      rules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' }
        ],
        wbName: [{ required: true, message: '请输入简称', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        // nameCH: [
        //   { required: true, message: '请输入中文全称', trigger: 'blur' }
        // ],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'change' }],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        supplierScope: [
          { required: true, message: '请选择业务范畴', trigger: 'blur' }
        ]
      },
      dialogVisible2: false,
      loading: false,
      fileList: [],
      tplList: [],
      file: {},
      headers: {
        ESCLEARANCE: btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`)
      },
      tableData1: {
        fileds: [
          {
            filed: 'accountName',
            label: '账号名称',
            width: ''
          },
          {
            filed: 'bankName',
            label: '银行名称',
            width: ''
          },
          {
            filed: 'accountNumber',
            label: '银行账号',
            width: ''
          },
          {
            filed: 'currency',
            label: '币制',
            width: ''
          },
          {
            filed: 'swiftCode',
            label: 'SwiftCode',
            width: ''
          },
          {
            filed: 'opt',
            label: '操作',
            width: '',
            isCustom: true
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['addressDropOption']),
    fileds() {
      if (this.active === 0) {
        return [
          {
            filed: 'fileName',
            label: '文件名',
            width: '',
            formatter: (row) => row.fileName || row.originalFileName
          },
          {
            filed: 'opt',
            label: '操作',
            width: '210px',
            isCustom: true
          }
        ]
      } else {
        return [
          {
            filed: 'fileName',
            label: '文件名',
            width: '',
            formatter: (row) => row.fileName || row.originalFileName
          },
          {
            filed: 'clearanceMode',
            label: '清关模式',
            width: '',
            formatter: (row) => {
              const arr = [
                {
                  value: 1,
                  label: 'T01'
                },
                {
                  value: 2,
                  label: 'T11'
                }
              ]
              return arr.find((a) => a.value === row.clearanceMode)?.label
            }
          },
          {
            filed: 'opt',
            label: '操作',
            width: '210px',
            isCustom: true
          }
        ]
      }
    }
  },
  watch: {
    drawer: function(val) {
      if (val) {
        console.log(this.editData)
        if (this.editData.id) {
          const supplierScope = []
          // 确保 editData.scopeTypes 存在且 supplierScopeOptions 已经加载
          if (
            this.editData.scopeTypes &&
            this.supplierScopeOptions.length > 0
          ) {
            this.editData.scopeTypes.map((item) => {
              const foundItem = this.supplierScopeOptions.find(
                (a) => +a.id === +item,
              )
              if (foundItem) {
                // 确保找到了匹配项
                supplierScope.push(foundItem.value)
              }
            })
          }
          const addressArr = [
            this.editData.countryId,
            this.editData.provinceId,
            this.editData.cityId
          ]
          this.supplyData = {
            ...this.editData,
            addressArr,
            supplierScope
          }
          this.bankAccountList = [...this.editData.bankAccount]
          this.getTplList()
        } else {
          this.supplyData = {
            code: '',
            // nameCH: '',
            // nameEN: '',
            name: '',
            wbName: '',
            contact: '',
            phone: '',
            email: '',
            address: '',
            addressArr: [],
            countryId: 0,
            provinceId: 0,
            cityId: 0,
            remark: '',
            ggtSecretKey: '',
            fmsSecretKey: '',
            isActived: true,
            doName: '',
            doContact: '',
            doPhone: '',
            doAddress: '',
            doDetailedAddress: '',
            supplierScope: [],
            bankAccount: [],
            fileList: [],
            clearanceModes: ''
          }
          this.bankAccountList = []
          this.tplList = []
        }
      }
    }
  },
  created() {
    this.getCommData()
  },
  methods: {
    async getTplList() {
      try {
        const res = await GetSupplierTemplates({
          supplierId: this.editData.id
        })
        if (res.success) {
          this.tplList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    tabChange(type) {
      this.active = type.id
    },
    close() {
      this.$emit('close')
      this.active = 0
    },
    cancel() {
      this.$refs['form'].resetFields()
      this.bankAccountList = []
      this.active = 0
      this.$emit('close')
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.bankAccountList.length === 0) {
          //   this.$message.warning('请添加银行账号')
          //   return
          // }
          const supplierScope = []
          this.supplyData.supplierScope.map((item) => {
            const a = this.supplierScopeOptions.find((b) => b.value === item)
            supplierScope.push({
              scopeDescription: a.label,
              scopValue: a.value,
              id: a.id
            })
          })
          let flag2 = true
          this.supplyData.truckEmails?.split(/[,;，；\n]/).forEach((a) => {
            if (!isValidEmail(a)) flag2 = false
          })
          if (!flag2) {
            this.$message.error('请填写正确格式的邮箱')
            return
          }
          const params = {
            ...this.supplyData,
            countryId: this.supplyData.addressArr[0],
            provinceId: this.supplyData.addressArr[1],
            cityId: this.supplyData.addressArr[2],
            scopeTypes: supplierScope.map((a) => a.id),
            bankAccount: [...this.bankAccountList],
            fileIds: this.supplyData.fileList.map((a) => a.id),
            truckEmails: this.supplyData.truckEmails
          }
          if (!this.editData.id) {
            insertSupplier(params).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          } else {
            updateSupplier(params).then((res) => {
              if (res.success) {
                this.$message.success('修改成功')
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          }
        }
      })
    },
    ok2(data) {
      this.bankAccountList.push({
        ...data
      })
      this.dialogVisible2 = false
    },
    cancel2() {
      this.dialogVisible2 = false
    },
    add() {
      this.dialogVisible2 = true
    },
    removeBankAccountList(index, item) {
      this.$confirm('此操作将删除该银行账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          deleteSupplierBankAccount({
            id: item.id
          }).then((res) => {
            if (res.success) {
              this.$message.success('操作成功')
              this.bankAccountList.splice(index, 1)
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    getCommData() {
      getSysParams({ type: 12 }).then((res) => {
        if (res.success) {
          const arr = []
          res.data &&
            res.data[0].value &&
            res.data[0].value.map((item) => {
              arr.push({
                label: item.description,
                value: item.dbValue,
                id: item.id
              })
            })
          this.supplierScopeOptions = arr
        }
      })
    },
    checkFile(id) {
      window.open(`/api/SystemFile/preview?guid=${id}`)
    },
    download(id) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = `/api/SystemFile/downLoadFile?guid=${id}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    async downloadTpl(row) {
      window.open(row.systemFilePath)
    },
    onSuccess(res) {
      this.loading = false
      if (!res.success) {
        this.$message.error(res.errorMessage)
        this.fileList = []
        return
      }
      if (this.active === 1) {
        this.getTplList()
      } else if (this.active === 0) {
        this.supplyData.fileList.push({
          fileName: this.file.name,
          fileGuid: res.data.fileGuid,
          id: res.data.id
        })
        this.fileList = []
        this.file = {}
      }
    },
    onError(error) {
      this.loading = false
      this.$message.error('上传失败')
      console.error(error)
    },
    onProgress(event, file) {
      this.loading = true
      this.file = file
    },
    async review(item) {
      if (this.active !== 1) {
        const { fileName: name } = item
        const suffix = name.slice(name.lastIndexOf('.') + 1, name.length)
        if (
          suffix.toLowerCase() === 'jpg' ||
          suffix.toLowerCase() === 'jpeg' ||
          suffix.toLowerCase() === 'png'
        ) {
          this.$viewerApi({
            images: [item.filePath]
          })
        } else if (suffix.toLowerCase() === 'pdf') {
          window.open(item.filePath)
        }
      } else {
        this.loading = true
        await derive('InvoiceTemplate/FillTemplateBySupplierTemplate', 'get', {
          templateId: item.id
        })
        this.loading = false
      }
    },
    onChange(index, item, active) {
      const cuurentStatus = item.isActived
      if (active === 1) {
        this.$confirm('此操作将激活该发票/预报模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(() => {
            isActivedSupplierTemplate({
              supplierId: this.editData.id,
              templateId: item.id
            }).then((res) => {
              if (res.success) {
                this.$message.success('操作成功')
                this.getTplList()
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          })
          .catch(() => {
            // 如果用户取消了操作，恢复开关的状态
            this.$set(this.tplList[index], 'isActived', !cuurentStatus)
          })
      } else if (active === 2) {
        this.$confirm('此操作将启用该银行账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        })
          .then(() => {
            switchSupplierBankAccount({
              id: item.id
            }).then((res) => {
              if (res.success) {
                this.$set(
                  this.bankAccountList[index],
                  'isActived',
                  cuurentStatus,
                )
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          })
          .catch(() => {
            // 如果用户取消了操作，恢复开关的状态
            this.$set(this.bankAccountList[index], 'isActived', !cuurentStatus)
          })
      }
    },
    deleteRow(index, item) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(() => {
          if (this.active !== 1) {
            this.supplyData.fileList.splice(index, 1)
          } else {
            deleteSupplierTemplate({
              supplierId: this.editData.id,
              templateId: item.id
            }).then((res) => {
              if (res.success) {
                this.$message.success('删除成功')
                this.getTplList()
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.view {
  width: 100%;
  height: calc(100% - 110px);
  margin: 0 auto;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 0 40px;
  .content {
    width: 1091px;
    // height: 740px;
    height: auto;
    background: #fff;
    box-sizing: border-box;
    margin-top: 10px;
    line-height: 24px;
    &:deep(.el-form-item__label) {
      height: 20px;
      line-height: 20px;
    }
    &:deep(.el-form-item) {
      margin-bottom: 20px;
    }
  }
  .add-item-content {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .title {
    align-self: flex-end;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .add-item {
    min-width: 120px;
    height: 40px;
    background: #35ba83;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    & + .add-item {
      margin-right: 16px;
    }
  }
  .baseTable {
    width: 100%;
    max-height: 200px;
    border: 1px solid #eeeeee;
    margin-top: 10px;
    border-radius: 4px 4px 4px 4px;
    overflow: hidden;
    box-sizing: border-box;
    i {
      color: rgb(18, 88, 188);
      font-size: 16px;
      margin-left: 15px;
      & + i {
        margin-top: 5px;
      }
    }
  }
  .upload {
    width: 420px;
    height: 100px;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    width: 160px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgb(18, 88, 188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    .icon {
      font-size: 24px;
      vertical-align: middle;
    }
  }
}
.foooter {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
    margin-right: 20px;
  }
  .ok {
    background: rgb(18, 88, 188);
    color: #ffffff;
  }
}
</style>
